import { CardHeader as NovaCardHeader, CardHeaderProps as NovaCardHeaderProps } from '@fme-nova/components'
import { CardHeaderProps as MuiCardHeaderProps, default as MuiCardHeader } from '@mui/material/CardHeader'

import { createComponentWrapperWithRef } from '../../theme'

export const CardHeader = createComponentWrapperWithRef<MuiCardHeaderProps | NovaCardHeaderProps>(
  {
    mui: MuiCardHeader,
    nova: NovaCardHeader,
  },
  'CardHeader',
)
